const Building = ({ size=24, color="#000000", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M6.75 6.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M6.75 10.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M6.75 14.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M12 6.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M12 10.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M12 14.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.25 6.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.25 10.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.25 14.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M21 3.75v19.5H3V3.75" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M18.5 3.75v-3h-13v3" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M23.25 23.25H0.75" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M22.25 3.75H1.75" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M6.75 18.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.25 18.75v1" strokeWidth="1.5"></path>
        <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14 23.25v-2.5c0 -1.1 -0.9 -2 -2 -2s-2 0.9 -2 2v2.5" strokeWidth="1.5"></path>
    </svg>
);

export default Building;
